var exports = {
  "kL": "xfb577c5e--90e7b5--container",
  "Kk": "xfb577c5e--90e7b5--icon",
  "Pf": "xfb577c5e--90e7b5--label",
};

module.exports = exports;
